import { render, staticRenderFns } from "./DashBoardTopCards.vue?vue&type=template&id=3fee37f4&scoped=true"
import script from "./DashBoardTopCards.vue?vue&type=script&lang=js"
export * from "./DashBoardTopCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fee37f4",
  null
  
)

export default component.exports